import { DoubleFixtureCell } from './DoubleFixtureCell';
import { EmptyFixtureCell } from './EmptyFixtureCell';
import { FixtureCell } from './FixtureCell';
import type { GameweekFixtures } from './constants';

type FixtureRowProps = {
  gameweeks: GameweekFixtures[];
  hiddenGameweeks?: number[];
  fixtureCellWidth: number;
  rowHeight: number;
  // When true, columns flex to fill the available width instead of using a
  // fixed pixel width (used by the homepage mini ticker, which has no scroll).
  stretch?: boolean;
};

export const FixtureRow = ({
  gameweeks,
  hiddenGameweeks = [],
  fixtureCellWidth,
  rowHeight,
  stretch = false
}: FixtureRowProps) => (
  <div className={`flex gap-1 ${stretch ? 'flex-1' : ''}`}>
    {gameweeks.map((gameweek) => {
      const cellStyle = stretch
        ? { height: rowHeight }
        : { width: fixtureCellWidth, height: rowHeight };
      const cellClassName = stretch ? 'flex-1' : '';

      // Hidden columns keep their slot (so headers and cells stay aligned) but
      // collapse to a muted placeholder. Clicking the header restores them.
      if (hiddenGameweeks.includes(gameweek.gameweek)) {
        return (
          <div
            key={gameweek.gameweek}
            style={cellStyle}
            className={`flex items-center justify-center ${cellClassName}`}
          >
            <div className="h-1 w-4 rounded-full bg-neutral-200" />
          </div>
        );
      }

      if (gameweek.fixtures.length === 0) {
        return (
          <div
            key={gameweek.gameweek}
            style={cellStyle}
            className={cellClassName}
          >
            <EmptyFixtureCell />
          </div>
        );
      }

      if (gameweek.fixtures.length === 1) {
        return (
          <div
            key={gameweek.gameweek}
            style={cellStyle}
            className={cellClassName}
          >
            <FixtureCell fixture={gameweek.fixtures[0]} />
          </div>
        );
      }

      return (
        <div
          key={gameweek.gameweek}
          style={cellStyle}
          className={cellClassName}
        >
          <DoubleFixtureCell
            fixtureOne={gameweek.fixtures[0]}
            fixtureTwo={gameweek.fixtures[1]}
          />
        </div>
      );
    })}
  </div>
);
